import React, { memo } from "react";
import { useGameTimer } from "./index.hooks";
import { Box, Typography } from "@mui/material";
import TimerIcon from "assets/ui-icons/timer.svg";

type GameTimerProps = {};

export const GameTimer = memo(({}: GameTimerProps) => {
  const { formattedTimeLeft } = useGameTimer();

  return (
    <Box
      sx={{
        width: "100%",
        backgroundColor: "#FFF",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center",
        borderBottomRightRadius: 30,
        borderTopRightRadius: 30,
        pr: "2em",
        py: "15px",
      }}
    >
      <Box component="img" src={TimerIcon} sx={{ mr: 2 }} />
      <Typography
        sx={{
          color: "#DD052B",
          fontSize: { xs: 20, md: 25 },
        }}
      >
        {formattedTimeLeft}
      </Typography>
    </Box>
  );
});
